import { tokens } from "@trustpilot/design-tokens";
import facepaint from "facepaint";

import { MakeStyles, Styles } from "./types";

const breakpointsSizes = [768, 1024];
const mediaQueriesSizes = breakpointsSizes.map((bp) => `@media(min-width: ${bp}px)`);
const mediaQueries = facepaint(mediaQueriesSizes);

export const getNavigationWidth = (isCollapsed = false) => {
  return isCollapsed ? 58 : 240;
};

const makeStyles = (props: MakeStyles = {}): Styles => ({
  global: {
    app: {
      body: {
        backgroundColor: tokens.colorBaseExtendedStone98,
        backgroundImage: [
          "none",
          // The gradient is there to look like the Header component,
          // so the top space is not empty when there is no header.
          `linear-gradient(
          ${tokens.colorBaseTrustpilotBrandNeutralWhite} 67px,
          ${tokens.colorBaseTrustpilotBrandNeutralWhite}  68px,
          ${tokens.colorBaseExtendedGray90} 68px,
          ${tokens.colorBaseExtendedGray90} 69px,
          ${tokens.colorBaseExtendedStone98} 69px,
          ${tokens.colorBaseExtendedStone98} 100%
          )`,
          `linear-gradient(
            ${tokens.colorBaseTrustpilotBrandNeutralWhite} 67px,
            ${tokens.colorBaseTrustpilotBrandNeutralWhite}  68px,
            ${tokens.colorBaseExtendedGray90} 68px,
            ${tokens.colorBaseExtendedGray90} 69px,
            ${tokens.colorBaseExtendedStone98} 69px,
            ${tokens.colorBaseExtendedStone98} 100%
            )`,
        ],
        backgroundRepeat: "no-repeat",
      },
      ".businessapp": mediaQueries({
        display: [null, "contents", "contents"],
        maxHeight: null,
        overflow: null,
      }),
      ".businessapp > div": mediaQueries({
        display: [null, "flex", "flex"],
      }),
      ".businessapp__wrapper": mediaQueries({
        width: [
          null,
          props.useSimplifiedLayout ? "100%" : `calc(100% - 58px)`,
          props.useSimplifiedLayout ? "100%" : `calc(100% - 240px)`,
        ],
        paddingBottom: 56,
        transition: [null, null, "transform 0.2s ease-in-out"],
      }),
      ".businessapp__wrapper--active-nav": mediaQueries({
        transform: [null, null, "translateX(240px)"],
        transition: [null, null, "transform 0.2s ease-in-out"],
        overflow: "hidden",
      }),
      ".businessapp__wrapper.error": mediaQueries({
        marginTop: [0, 69, 69],
        overflow: "hidden",
      }),
      ".businessapp__wrapper--active-nav div[class*=StyledHeader] h2": {
        "@media screen and (min-width: 1024px) and (max-width: 1200px)": {
          maxWidth: "400px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
      },
    },
  },
  appShell: {
    wrapper: mediaQueries({
      width: [null, props.useSimplifiedLayout ? null : "58px", props.useSimplifiedLayout ? null : "240px"],
      minHeight: props.useSimplifiedLayout ? 0 : 67,
      height: props.useSimplifiedLayout ? 0 : 67,
      position: props.useSimplifiedLayout ? "absolute" : "static",
      right: props.useSimplifiedLayout ? 0 : null,
    }),
    content: mediaQueries({
      position: "fixed",
      zIndex: 80,
      left: 0,
      top: 0,
      width: [
        "100%",
        props.useSimplifiedLayout ? 0 : getNavigationWidth(props.isCollapsed),
        props.useSimplifiedLayout ? 0 : getNavigationWidth(props.isCollapsed),
      ],
      height: [null, "100%", "100%"],
      display: [null, "flex", "flex"],
      flexDirection: "column",
    }),
    leftNav: mediaQueries({
      display: [null, "flex", "flex"],
      overflow: [null, "hidden", "hidden"],
      flexGrow: 1,
    }),
  },
});

export { makeStyles };
